import { create } from 'zustand';

interface ThemeState {
  preferredTextColor: string;
  preferedPrimaryHexColor: string;
  setPreferredTextColor: (preferredTextColor: string) => void;
  setPreferedPrimaryHexColor: (preferedPrimaryHexColor: string) => void;
}

const useThemeStore = create<ThemeState>()((set) => ({
  preferredTextColor: '#000000',
  preferedPrimaryHexColor: '#27c9a9',
  setPreferredTextColor: (preferredTextColor) => set({ preferredTextColor }),
  setPreferedPrimaryHexColor: (preferedPrimaryHexColor) =>
    set({ preferedPrimaryHexColor })
}));

export default useThemeStore;
